import { INftType, ITokenType } from '~/types/token-type.type'
import { getRouteParam } from '~/utils/route.util'

export const useTokenType = <T extends ITokenType | INftType = ITokenType>(defaultValue?: T) => {
  const tokenTypeParam = getRouteParam('tokenType').toUpperCase() as T
  const tokenTypeValue = defaultValue ?? tokenTypeParam

  const isErc20 = computed(() => {
    return tokenTypeValue === ITokenType.ERC20
  })

  const isErc721 = computed(() => {
    return tokenTypeValue === ITokenType.ERC721
  })

  const isErc1155 = computed(() => {
    return tokenTypeValue === ITokenType.ERC1155
  })

  return {
    tokenTypeValue,
    isErc20,
    isErc721,
    isErc1155,
  }
}